import React, { useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

const useConfirmationModal = () => {
  const [open, setOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(null);

  const openModal = (confirmCallback) => {
    setOnConfirm(() => confirmCallback);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    closeModal();
  };

  return {
    open,
    openModal,
    closeModal,
    handleConfirm,
    ModalComponent: () => (
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="confirmation-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" id="confirmation-modal" gutterBottom>
            Möchten Sie dies wirklich löschen?
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
          Dieser Vorgang kann nicht rückgängig gemacht werden
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              onClick={closeModal}
              sx={{ flex: 1, mr: 1 }}
            >
              abbrechen
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirm}
              sx={{ flex: 1, ml: 1 }}
            >
              bestätigen
            </Button>
          </Box>
        </Box>
      </Modal>
    ),
  };
};
export default useConfirmationModal;